import React from "react";
import "./AddMission.css";
import { useNavigate } from "react-router-dom";
import { BarLoader } from "react-spinners";
import AddMissionForm from "../../../../Components/Organisms/Forms/AddMissionForm/AddMissionForm";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AddMission({ category, loading, mission, isEdit = false }) {
  const navigate = useNavigate();

  return (
    <div className="mainContainer">
      {category && !loading ? (
        <div className="Cont">
          <div className="addMissionFormContainer">
            <AddMissionForm
              category={category}
              mission={mission}
              isEdit={isEdit}
            />
          </div>
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default AddMission;
